import * as actions from './actions'
import * as getters from './getters'
import mutations from './mutations'

export default {
  namespaced: true,
  state: {
    authenticated: !!localStorage.getItem('access_token'),
    accessToken: localStorage.getItem('access_token'),
    idToken: localStorage.getItem('id_token'),
    expiresAt: localStorage.getItem('expires_at'),
    profile: JSON.parse(localStorage.getItem('profile'))
  },
  getters,
  mutations,
  actions
}
